export const E_COMMERCE_CHANNEL_ID = '4';
